// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__33Rtu","legacyBtn":"MutateMid_legacyBtn__2xFW8"};